/**
 * PHP upload: `menthorship_cover` → CDN `/mc/`, `menthor_pic` → `/mp/`,
 * `menthorship_image` → `/mi/` (сошиал / OG).
 * DB жишээ: `4/6EPJ-0ONDN8-JNHVQI-972I54-VNI8` — өргөтгөлгүй бол `.jpg` залгана.
 *
 * Хуучин:
 * - `files/...` → `{cdn}/files/...`
 * - `r/...` эсвэл нэг токен (folderгүй) → `{cdn}/r/....jpg`
 */

function cdnBase(): string {
  return (process.env.NEXT_PUBLIC_CDN_URL || '').trim().replace(/\/$/, '');
}

function withCdn(publicPath: string): string {
  const cdn = cdnBase();
  const p = publicPath.startsWith('/') ? publicPath : `/${publicPath}`;
  return cdn ? `${cdn}${p}` : p;
}

function buildMentorshipCdnUrl(
  filename: string | null | undefined,
  bucket: 'mc' | 'mi' | 'mp',
): string {
  const raw = (filename || '').trim();
  if (!raw) {
    return '/mentorship/thumbnail.png';
  }
  if (raw.startsWith('http://') || raw.startsWith('https://')) {
    return raw;
  }

  const path = raw.replace(/^\/+/, '');

  if (/^files\//i.test(path)) {
    return withCdn(path);
  }

  /** Шинэ: `компани/токен` — PHP SUBDIR_Y */
  if (/^\d+\/.+/i.test(path)) {
    const withExt = /\.(jpe?g|png|gif|webp|svg)$/i.test(path)
      ? path
      : `${path}.jpg`;
    return withCdn(`${bucket}/${withExt}`);
  }

  if (path.startsWith('r/')) {
    return withCdn(path);
  }

  const hasImageExt = /\.(jpe?g|png|gif|webp|svg)$/i.test(path);
  const filePart = hasImageExt ? path : `${path}.jpg`;
  return withCdn(`r/${filePart}`);
}

/** Програмын banner / poster */
export function mentorshipProgramCoverUrl(
  filename: string | null | undefined,
): string {
  return buildMentorshipCdnUrl(filename, 'mc');
}

/** Сошиал / thumbnail (`job_mentorship_medias`, PHP `menthorship_image`) */
export function mentorshipProgramSocialUrl(
  filename: string | null | undefined,
): string {
  return buildMentorshipCdnUrl(filename, 'mi');
}

/** Менторын профайл зураг */
export function mentorshipMentorImageUrl(
  filename: string | null | undefined,
): string {
  return buildMentorshipCdnUrl(filename, 'mp');
}
